import { useState } from "react";
import { FileText, Sparkles, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import GenerateCostDialog from "@/components/ai/GenerateCostDialog";
import BriefDialog from "./BriefDialog";
import { useEditor } from "./useEditorState";

// «Modifica brief» + «Genera sito completo» on an existing project: reuses the saved brief, cost confirmation mandatory,
// the current content is saved as a version before being replaced (server side).
export function useGenerateFlow() {
  const ed = useEditor();
  const [dlg, setDlg] = useState(null);
  const hasContent = ed.content.pages.some((p) => p.sections.length);
  const started = (data) => { setDlg(null); ed.setProject((p) => ({ ...p, generation: { status: "running", job_id: data.job_id } })); };
  const dialogs = (
    <>
      <BriefDialog open={dlg === "brief"} onOpenChange={(o) => !o && setDlg(null)} onSavedGenerate={() => setDlg("gen")} />
      <GenerateCostDialog open={dlg === "gen"} onOpenChange={(o) => !o && setDlg(null)} api={ed.api} projectId={ed.project.id} body={hasContent ? { confirm_overwrite: true } : undefined}
        onBeforeStart={ed.save} onStarted={started} title={hasContent ? "Generare il sito completo con l'AI?" : "Generare il sito con l'AI?"}
        description={hasContent ? "Usa il brief salvato. Il contenuto attuale viene salvato in una versione (ripristinabile da «Versioni») e poi sostituito. Se la generazione non riesce, il progetto e la bozza restano." : "Usa il brief salvato. Se la generazione non riesce, il progetto resta com'è."} />
    </>);
  return { open: setDlg, dialogs, hasContent };
}

export default function GenerateBanner() {
  const { project } = useEditor();
  const [hidden, setHidden] = useState(false);
  const flow = useGenerateFlow();
  if (hidden || project.generation || project.is_template || project.start_mode !== "ai") return null;
  return (
    <div className="absolute left-1/2 top-3 z-20 w-[min(680px,calc(100%-24px))] -translate-x-1/2 rounded-xl border border-sky-200 bg-white/95 p-3 shadow-lg backdrop-blur" data-testid="generate-banner">
      <div className="flex flex-wrap items-center gap-2">
        <p className="w-full text-sm text-slate-700"><b className="text-slate-900">Sito non ancora generato con l'AI.</b> Il brief del wizard è salvato{flow.hasContent ? " e le sezioni aggiunte a mano restano finché non generi (vengono salvate in una versione)" : ""}: controllalo e avvia la generazione quando vuoi.</p>
        <div className="ml-auto flex items-center gap-2">
        <Button size="sm" variant="outline" onClick={() => flow.open("brief")} data-testid="banner-edit-brief"><FileText size={14} className="mr-1.5" />Modifica brief</Button>
        <Button size="sm" className="bg-sky-600 hover:bg-sky-700" onClick={() => flow.open("gen")} data-testid="banner-generate"><Sparkles size={14} className="mr-1.5" />Genera sito completo</Button>
        <button type="button" onClick={() => setHidden(true)} aria-label="Chiudi avviso" className="rounded p-1 text-slate-400 hover:text-slate-700" data-testid="banner-close"><X size={14} /></button>
        </div>
      </div>
      {flow.dialogs}
    </div>);
}
